

import { fetchPersea } from "@/config/axios/config-axios";
import { ExchangeClaimBodyType } from "@/types/campaign/exchange-claim/exchange-claim";

export const campaignExchangeClaim = async (body: ExchangeClaimBodyType) => {
  return await fetchPersea(`/campaign/mission/exchange/claim`, 'POST', {}, body);
};